import React from "react";
import Catalog from "../components/Catalog/Catalog";

const CatalogPage: React.FC = () => {
  return (
    <div className="min-h-screen">
      <div className="pt-16 sm:pt-20" />
      <Catalog />
    </div>
  );
};

export default CatalogPage; 